<script setup>
defineProps({
  title: { type: String, required: true },
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['close']);
</script>

<template>
  <Teleport to="body">
    <div v-if="show" class="aj-modal-overlay" @click.self="emit('close')">
      <div class="aj-modal-panel">
        <div class="aj-modal-header">
          <h3>{{ title }}</h3>
          <button class="aj-modal-close" @click="emit('close')">✕</button>
        </div>
        <div class="aj-modal-body">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.aj-modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4); z-index: 200;
  display: flex; align-items: flex-end; justify-content: center;
  backdrop-filter: blur(2px);
}
@media (min-width: 768px) {
  .aj-modal-overlay { align-items: center; }
}
.aj-modal-panel {
  background: rgb(var(--slate-1, 252 252 253));
  border-radius: 16px 16px 0 0; width: 100%; max-width: 480px;
  max-height: 85vh; overflow-y: auto;
  animation: ajSlideUp .25s cubic-bezier(0.32,0.72,0,1);
  box-shadow: 0 -4px 24px rgba(0,0,0,0.12);
}
@media (min-width: 768px) {
  .aj-modal-panel { border-radius: 16px; max-height: 70vh; }
}
.aj-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid rgb(var(--slate-4, 232 232 236));
  position: sticky; top: 0; background: inherit; z-index: 1;
}
.aj-modal-header h3 { font-size: 15px; font-weight: 600; color: rgb(var(--slate-12, 28 32 36)); }
.aj-modal-close {
  background: rgb(var(--slate-3, 240 240 243)); border: none;
  width: 28px; height: 28px; border-radius: 8px; cursor: pointer;
  font-size: 14px; color: rgb(var(--slate-11, 96 100 108));
  display: flex; align-items: center; justify-content: center;
}
.aj-modal-close:hover { background: rgb(var(--slate-4, 232 232 236)); }
.aj-modal-body { padding: 16px 20px 20px; }
@keyframes ajSlideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
</style>
